/* istanbul ignore file */
import { SvgIconProps } from '@mui/material';

export const ImportIcon = (props: SvgIconProps) => {
    return (
        <svg {...props} fill="none" width="48" height="48" viewBox="0 0 48 48">
            <circle cx="24" cy="24" r="24" fill="#D1E9FF" />
            <path
                d="M33 27V31C33 31.5304 32.7893 32.0391 32.4142 32.4142C32.0391 32.7893 31.5304 33 31 33H17C16.4696 33 15.9609 32.7893 15.5858 32.4142C15.2107 32.0391 15 31.5304 15 31V27M19 22L24 27M24 27L29 22M24 27V15"
                stroke="#1570EF"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
